__turbopack_context__.v({
  "agenda": "Agenda-module-scss-module__sbL6wq__agenda",
  "header": "Agenda-module-scss-module__sbL6wq__header",
  "title": "Agenda-module-scss-module__sbL6wq__title",
});
